import { Report62Container } from "../../../containers/SupportSystem/Reports/Report62Container";
export function Report62Page() {
    return (
        <Report62Container />
    );

}